export const FaqData = [
    {
        sno: 1,
        question: "Who can participate? Are there any prerequisites or required skills?",
        ans: "The event is restricted only to the college students.There are no prior skills required.You don’t have to be a programmer and you certainly don’t need to have a degree in Computer Science! While experience in coding and programming is a huge plus, teams will also need people with strong presentation skills and brilliant ideas."
    },
    {
        sno: 2,
        question: "Is this a team event? What is the team size required for the hackathon?",
        ans: "This hackathon is both a team and individual event. You can participate on your own or form a team of people you know and register with your team on the website.The team may comprise of _____ members."
    },
    {
        sno: 3,
        question: "Are there any fees required to participate?",
        ans: "No, the event is entirely free!"
    },
    {
        sno: 4,
        question: "What sort of projects are we expected to come up with?",
        ans: "We’re welcoming all ideas aimed to boost and strengthen the event theme."
    },
    {
        sno: 5,
        question: "Will we recieve any support from coaches / mentors during the hackathon?",
        ans: ""
    },
    {
        sno: 6,
        question: "On what basis will the winners be selected?",
        ans: "There will be an independent Jury selecting the winners with a rating system. The judge panel composition will be announced closer to the date of the hackathon."
    },
]